import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.authService.token;
    let shouldAuth = this.shouldAuth(req);

    if (token && shouldAuth) {
      req = req.clone({ setHeaders: { 'Authorization': `Bearer ${token.value}` } });
    }

    return next.handle(req).catch(err => {
      if (err instanceof HttpErrorResponse && err.status === 401 && shouldAuth) {
        this.router.navigate(['/unauthorized']);
      }
      return Observable.throw(err);
    });
  }

  shouldAuth(req: HttpRequest<any>): boolean {
    return req.url.startsWith(Environment.apiUrl) && !req.url.startsWith(`${Environment.apiUrl}/token`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth-interceptor.service.ts